/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import LazyLoad from 'react-lazyload'

class Img extends React.PureComponent {
  render() {
    let srcPth = ''
    let { src, lazyload, ...rest } = this.props
    if (!isEmpty(src)) {
      if (process.env.NODE_ENV === 'development' && src.split('/')[0] !== 'https:') {
        srcPth = process.env.REACT_APP_IMG_PATH_DEV
      }
    }
    src = srcPth + src

    return lazyload ? (
      <LazyLoad offset={200} once>
        <img src={src} {...rest} />
      </LazyLoad>
    ) : (
      <img src={src} {...rest} />
    )
  }
}

Img.propTypes = {
  src: PropTypes.string.isRequired,
  lazyload: PropTypes.bool,
}

Img.defaultProps = {
  lazyload: true,
}

export default Img



// WEBPACK FOOTER //
// ./src/components/shared/elements/Img.js